import './style.scss';
import { Box } from '@mui/material';


interface IScrollableXProps {
    className?: string;
    hasContainer?: boolean;
    [rest: string]: any;
}

const ScrollableX: React.FC<IScrollableXProps> = ({
    className = '',
    hasContainer = false,
    ...rest
}) => {
    return <Box className={`scrollablex-container ${className} ${hasContainer ? 'with-container' : ''}`}>
        {rest.children}
    </Box>;
}

export default ScrollableX;